import graphqlClient from '../../../services/graphqlClient';
import {isNil} from 'ramda';
import getBusPartnerAndCountryCostEntryYearQuery from '../graphql/getBusPartnerAndCountryCostEntryYearQuery';
import createPartnerVehicleTypeCostMutation from '../graphql/createPartnerVehicleTypeCostMutation';
import deletePartnerVehicleTypeCostMutation from '../graphql/deletePartnerVehicleTypeCostMutation';
import updatePartnerVehicleTypeCostMutation from '../graphql/updatePartnerVehicleTypeCostMutation';
import {displayErrorMessage, displaySuccessMessage} from '../../Common/Utils';
import {
  receivedBusPartnerCostEntryYear,
  addToVehicleTypeCostAction,
  updateVehicleTypeCostAction,
  deleteFromVehicleTypeCostAction
} from './slice';

//
// Partner costs - Vehicle cost
//

export const fetchBusPartnerAndCountryCostEntryYear = (
  busPartnerId,
  year,
  countryId
) => {
  return dispatch => {
    if (isNil(busPartnerId) || isNil(year) || isNil(countryId)) {
      return;
    }

    graphqlClient
      .query({
        query: getBusPartnerAndCountryCostEntryYearQuery,
        variables: {busPartnerId, year, countryId},
        fetchPolicy: 'no-cache',
        errorPolicy: 'all'
      })
      .then(
        ({data: {getBusPartnerCostEntryYear, countryCostEntry}, errors}) => {
          if (errors) {
            console.error('Error fetching cost entry, Errors:', errors);
          }

          dispatch(
            receivedBusPartnerCostEntryYear({
              ...getBusPartnerCostEntryYear,
              countryCostEntry
            })
          );
        }
      );
  };
};

export const createVehicleTypeCost = (
  vehicleTypeCost,
  partnerId,
  year,
  setCustomIdentifierErrorMessage
) => {
  return dispatch => {
    if (isNil(partnerId) || isNil(year)) {
      return;
    }

    graphqlClient
      .mutate({
        mutation: createPartnerVehicleTypeCostMutation,
        variables: {
          partnerId,
          year,
          busTypeId: vehicleTypeCost.busTypeId,
          leasingCost: vehicleTypeCost.leasingCost,
          insuranceCost: vehicleTypeCost.insuranceCost,
          interestCost: vehicleTypeCost.interestCost,
          motorVehicleTax: vehicleTypeCost.motorVehicleTax,
          maintenanceCostPerMonth: vehicleTypeCost.maintenanceCostPerMonth,
          maintenanceCostPerDistanceUnit:
            vehicleTypeCost.maintenanceCostPerDistanceUnit,
          vehicleRegistrationCost: vehicleTypeCost.vehicleRegistrationCost,
          customIdentifier: vehicleTypeCost.customIdentifier,
          vehicleProductionYear: vehicleTypeCost.vehicleProductionYear
        },
        errorPolicy: 'all'
      })
      .then(result => {
        const {
          data: {createBusPartnerBusTypeCostEntry},
          errors
        } = result;
        if (errors) {
          setCustomIdentifierErrorMessage(
            errors[0]?.extensions?.errorMessage || errors[0].message
          );
        } else {
          setCustomIdentifierErrorMessage(null);
          dispatch(
            addToVehicleTypeCostAction(createBusPartnerBusTypeCostEntry)
          );
        }
      });
  };
};

export const updateVehicleTypeCost = (
  vehicleTypeCost,
  partnerId,
  year,
  setCustomIdentifierErrorMessage
) => {
  return dispatch => {
    if (isNil(partnerId) || isNil(year)) {
      return;
    }

    graphqlClient
      .mutate({
        mutation: updatePartnerVehicleTypeCostMutation,
        variables: vehicleTypeCost,
        errorPolicy: 'all'
      })
      .then(result => {
        const {
          data: {updateBusPartnerBusTypeCostEntry},
          errors
        } = result;
        if (errors) {
          setCustomIdentifierErrorMessage(
            errors[0]?.extensions?.errorMessage || errors[0].message
          );
        } else {
          setCustomIdentifierErrorMessage(null);
          dispatch(
            updateVehicleTypeCostAction(updateBusPartnerBusTypeCostEntry)
          );
        }
      });
  };
};

export const deleteVehicleTypeCost = (vehicleTypeCostId, addToast) => {
  return dispatch => {
    graphqlClient
      .mutate({
        mutation: deletePartnerVehicleTypeCostMutation,
        variables: {id: vehicleTypeCostId},
        errorPolicy: 'all'
      })
      .then(result => {
        let {
          data: {deleteBusPartnerBusTypeCostEntry},
          errors
        } = result;
        if (errors) {
          displayErrorMessage(
            addToast,
            errors[0]?.extensions?.errorMessage || errors[0].message
          );
        } else {
          displaySuccessMessage(
            addToast,
            'Vehicle type cost deleted successfully'
          );
        }
        dispatch(
          deleteFromVehicleTypeCostAction(deleteBusPartnerBusTypeCostEntry)
        );
      });
  };
};
